import microuniversoApi from "app/api/microuniversoApi"
import React, { useEffect, useRef, useState, useCallback, useMemo } from "react"
import { IniciarOrcamento } from "./IniciarOrcamento"
import { Vendedor } from "../../types/Vendedor";
import { tratamentoErroPadrao } from "../../use-cases";
import { obterParametros } from "app/use-cases/parametro/obterParametros";
import { Parametro } from "app/types/Parametro";
import { MicrouniversoApi } from "app/api/classes/MicrouniversoApi";
import globalMU from "globalMU";

export type IniciarOrcamentoContainerProps = {
    tipoOrcamento: string
    onCancelar: () => void
}

export const IniciarOrcamentoContainer = (props: IniciarOrcamentoContainerProps) => {
    const isMounted = useRef<boolean>(true)
    useEffect(() => () => { isMounted.current = false }, [])

    const [filiais, setFiliais] = useState<{Oid: number, Descricao: string}[]>([])
    const [oidFilialUsuarioLogado, setOidFilialUsuarioLogado] = useState<number | null>(null)
    const [vendedorLogado, setVendedorLogado] = useState<Vendedor | null>(null)
    const [urlLogo, setUrlLogo] = useState<string | null>(null)
    const [realizandoProcessamento, setRealizandoProcessamento] = useState<boolean>(false);
    const [parametros, setParametros] = useState<Parametro[]>([])
    const [desativarAlteracaoFilial, setDesativarAlteracaoFilial] = useState<boolean | null>(null)

    const valorParametro = useCallback((nome: string) => {
        return parametros.find(p => p.Nome === nome)?.Valor
    }, [parametros])

    const atualizarValoresParametros = useCallback(async () => {
        const params = await obterParametros({nomes: [
            "ALTERAR_FILIAL_ORC",
            "PERMITIR_GERENTE_ALTERAR_FILIAL_ORC"
        ]})
        if (!isMounted.current) return
        setParametros(params)
    }, [])

    const atualizarOidFilialUsuarioLogado = useCallback(async () => {
        const oid = await microuniversoApi.Usuario.obterOidFilialUsuarioLogado()
        if (!isMounted.current) return
        setOidFilialUsuarioLogado(oid)
    }, [])

    const atualizarFiliais = useCallback(async () => {
        //488824 -- const filiais = await microuniversoApi.Vendedor.listarFiliaisOrcamento()
        const filiais = await microuniversoApi.Vendedor.ListarFiliaisOrcamentoSimplificado()     // 488824
        if (!isMounted.current) return
        setFiliais(filiais)
    }, [])

    const obterVendedor = useCallback(async () => {
        const vendedor = await microuniversoApi.Vendedor.ObterVendedorAutenticado()
        if (!isMounted.current) return
        setVendedorLogado(vendedor)
    }, [])

    const obterUrlLogo = useCallback(async () => {
        const url = await microuniversoApi.Usuario.obterUrlLogo()
        if (!isMounted.current) return
        setUrlLogo(url)
    }, [])

    const entrar = useCallback(async (oidFilial: number) => {
        try {
            setRealizandoProcessamento(true)
            globalMU.blockScreen()
            await microuniversoApi.Vendedor.alterarFilial(oidFilial)
            //const vendedor = await microuniversoApi.Vendedor.ObterVendedorAutenticado()
            //const sessaoAplicativo = (window as any).oidSessaoAplicativo
            
            //const snapshtoDados = await microuniversoApi.OrcamentoWebSnapshot.adicionarSnapshot(vendedor.Codigo, sessaoAplicativo, oidFilial)
            //await microuniversoApi.Orcamento.definirSnapshotId(snapshtoDados.id)
            //console.log("Snapshot criado com id: " + snapshtoDados.id)
            $(window).attr("permitirSairView", true)
            
            const tipo = props.tipoOrcamento === "VENDAS" ? 0 
                : props.tipoOrcamento === "OUTRAS_SAIDAS" ? 1 
                : props.tipoOrcamento === "TRANSFERENCIA" ? 2 : 0
            const abaId = sessionStorage.getItem('aba_id')
            window.location.href = `/Orcamento/IncluirOrcamento?tipoOrcamento=${tipo}&XAbaId=${abaId}`
        } catch (e) {
            tratamentoErroPadrao(e)
            globalMU.unblockScreen()
            if (!isMounted.current) return
            setRealizandoProcessamento(false)
        }
    }, [props.tipoOrcamento])

    useEffect(() => {
        globalMU.blockScreen()
        Promise.all([
            atualizarFiliais(),
            atualizarOidFilialUsuarioLogado(),
            obterVendedor(),
            obterUrlLogo(),
            atualizarValoresParametros()
        ]).then
        {
            globalMU.unblockScreen()
        }
    }, [atualizarFiliais, atualizarOidFilialUsuarioLogado, obterVendedor, obterUrlLogo, atualizarValoresParametros])

    useEffect(() => {
        
        if (valorParametro("ALTERAR_FILIAL_ORC") !== undefined 
            && valorParametro("PERMITIR_GERENTE_ALTERAR_FILIAL_ORC") !== undefined 
            && vendedorLogado !== null) {
            setDesativarAlteracaoFilial(
                valorParametro("ALTERAR_FILIAL_ORC") !== "S" 
                && (valorParametro("PERMITIR_GERENTE_ALTERAR_FILIAL_ORC") !== "S" 
                || !vendedorLogado.GerenciaOutrosVendedores)
            )
        }

        if (desativarAlteracaoFilial !== null 
            && !realizandoProcessamento 
            && filiais.length > 0 
            && filiais[0].Oid > 7 
            && oidFilialUsuarioLogado !== null 
            && oidFilialUsuarioLogado > 0 
            && vendedorLogado !== null) {
            if (filiais.length === 1) {
                entrar(filiais[0].Oid)
            } else if (desativarAlteracaoFilial 
                    && filiais.length > 1 
                    && oidFilialUsuarioLogado) {
                globalMU.blockScreen()
                entrar(oidFilialUsuarioLogado)
            } else if (desativarAlteracaoFilial 
                    && filiais.length > 1 
                    && vendedorLogado.OidFilial > 0) {
                    
                globalMU.blockScreen()
                entrar(vendedorLogado.OidFilial)
            }
        }
    }, [desativarAlteracaoFilial, filiais, oidFilialUsuarioLogado, vendedorLogado, parametros, valorParametro, entrar, realizandoProcessamento])

    return (
        <>
            {filiais.length > 0 && oidFilialUsuarioLogado !== null && vendedorLogado !== null && (
                <IniciarOrcamento 
                    urlLogo={urlLogo}
                    filiais={filiais}
                    onCancelar={props.onCancelar}
                    onEntrar={entrar}
                    oidFilialSelecionada={oidFilialUsuarioLogado}
                    vendedorLogado={vendedorLogado}
                    realizandoProcessamento={realizandoProcessamento}
                    desativarAlteracaoFilial={desativarAlteracaoFilial}
                />
            )}
        </>
    )
}
